export default __webpack_public_path__ + "static/media/helsinki-cathedral-g534db2a8e_1920.5fa5072f.jpg";